import { render, staticRenderFns } from "./ItemVariationAttribute.vue?vue&type=template&id=3d5b93da&scoped=true&"
import script from "./ItemVariationAttribute.vue?vue&type=script&lang=js&"
export * from "./ItemVariationAttribute.vue?vue&type=script&lang=js&"
import style0 from "./ItemVariationAttribute.vue?vue&type=style&index=0&id=3d5b93da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5b93da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VChip,VDivider})
